<fcp-modal
    [title]="titleText | translate"
    [size]="displayMode === DisplayMode.Desktop ? ModalSizes.Medium : ModalSizes.Mobile"
    [id]="productSwitchModalId"
>
    <div fcp-modal-content class="select-store-modal-container">
        {{ captionText | translate }}
    </div>
    <div fcp-modal-actions class="select-store-modal-actions">
        <button fcp-outlined-button size="large" (click)="cancel()">
            {{ cancelText | translate }}
        </button>
        <button fcp-button size="large" color="prominent" (click)="confirm()">
            {{ confirmText | translate }}
        </button>
    </div>
</fcp-modal>
